import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    HasOnError,
} from "@insite/client-framework/HandlerCreator";
import { getBranchCollection, BranchCollectionModel } from "@tCentro/Services/CENAdminBranchService";

export interface GetBranchCollectionParameter extends HasOnSuccess<BranchCollectionModel>, HasOnError<string> {
    page?: number;
    pageSize?: number;
    query?: string;
}

type HandlerType = ApiHandler<GetBranchCollectionParameter, { apiResult: BranchCollectionModel }>;

export const GetBranchCollection: HandlerType = async props => {
    try {
const result = await getBranchCollection(props.parameter.page, props.parameter.pageSize, props.parameter.query);
        if (props.parameter.onSuccess) {
            props.parameter.onSuccess(result);
        }
    } catch (error: any) {
        if (props.parameter.onError) {
            props.parameter.onError(error?.message ?? "Failed to load branches");
        }
    }
};

export const chain = [GetBranchCollection];
const getBranchCollectionData = createHandlerChainRunner(chain, "getBranchCollectionData");
export default getBranchCollectionData;
